import axios from 'axios';

import { HOST_API } from 'src/config-global';

export type StrapiAuthResponse = {
  jwt: string;
  user: { id: number; username: string; email: string };
};

/**
 * Exchanges a finished Auth0 login for a Strapi JWT.
 *
 * Strapi completed the Auth0 login itself and kept the result in its session
 * cookie, so the request must send that cookie (withCredentials). Uses plain
 * axios: this is a public endpoint and a stale Strapi JWT must not be sent.
 */
export const exchangeAuth0Login = async (): Promise<StrapiAuthResponse> => {
  const res = await axios.get<StrapiAuthResponse>(`${HOST_API}/api/auth/auth0/callback`, {
    withCredentials: true,
  });
  return res.data;
};
